import { ProjectProps } from "@/interfaces/project_types";
import { ProjectCard } from "./ProjectCard";

export function ClientSection({ client, projects, index }: { client: string; projects?: ProjectProps[]; index: number; }) {
    return (
        <div key={index} className="my-5">
            <h4 className="px-2">Total Projects: {projects && projects.filter(project => project.client?.name === client).length}</h4>

            {/* The column headers */}
            <div className="grid grid-cols-6 p-4 border-b-2 bg-slate-50">
                <h3>{client}</h3>
                <h3>Project ID</h3>
                <h3>Project Name</h3>
                <h3>On-Going Status</h3>
                <h3>Checklist</h3>
            </div>

            <div>
                {projects && projects.filter(project => project.client?.name === client).map((project, index) => <ProjectCard project={project} index={index} key={index} />
                )}
            </div>
        </div>
    )
}
